import { closingAttorneyContactCard } from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const SCOverrides: OfferLocaleOverrides = {
  locale: 'SC',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.section',
                  size: 50,
                },
                {
                  name: 'property.subdivision',
                  size: 50,
                },
              ],
              [
                {
                  name: 'property.lot',
                  size: 50,
                },
                {
                  name: 'property.block',
                  size: 50,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number (PID/PIN/Tax Map)',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText:
                'Copy legal description from appraisal district site. Be sure lot and block is only included in the lot and block fields above and does not repeat in this field...',
            },
            section: {
              name: 'property.section',
              entity: 'property',
              type: 'text',
              label: 'Section/Phase',
              placeholderText: '',
            },
            subdivision: {
              name: 'property.subdivision',
              entity: 'property',
              type: 'text',
              label: 'Subdivision',
              placeholderText: '',
            },
            lot: {
              name: 'property.lot',
              entity: 'property',
              type: 'text',
              label: 'Lot',
              placeholderText: '',
            },
            block: {
              name: 'property.block',
              entity: 'property',
              type: 'text',
              label: 'Block',
              placeholderText: '',
            },
          },
        },
        emdCard: {
          fields: {
            numbersDaysEmdDue: null,
            emdDueDate: {
              name: 'emdDueDate',
              entity: 'interaction',
              type: 'date',
              label: 'EMD Due Date',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: null,
        attorneyContactCard: () => closingAttorneyContactCard,
      },
    },
  },
};
